import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { forgotPasword, resetPassword } from "../../features/auth/authSlice";
import toast from "react-hot-toast";

const ForgotPasswordModal = ({ show, onClose }) => {
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    code: "",
    password: "",
    confirmPassword: "",
  });
  const dispatch = useDispatch();
  const validatePassword = (password) => {
    const strongRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!password) return "";
    if (!strongRegex.test(password)) {
      return "Password must include A–Z, a–z, 0–9 & symbol (8+).";
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Live password validation
    if (name === "password") {
      const error = validatePassword(value);
      setPasswordError(error);

      // Also re-check confirm password while typing password
      if (formData.confirmPassword) {
        setConfirmPasswordError(
          value !== formData.confirmPassword ? "Passwords do not match" : "",
        );
      }
    }

    // Live confirm password match check
    if (name === "confirmPassword") {
      setConfirmPasswordError(
        value !== formData.password ? "Passwords do not match" : "",
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (step === 1) {
      const email = formData.email;
      const response = await dispatch(forgotPasword(email)).unwrap();
      console.log("Step 1 → Email submitted:", formData.email);
      console.log("Backend response:", response);
      setStep(2);
    } else if (step === 2) {
      if (passwordError || confirmPasswordError) {
        toast.error("Please fix the errors");
        return;
      }

      dispatch(
        resetPassword({
          email: formData.email,
          otp: formData.code,
          password: formData.password,
          confirm_password: formData.confirmPassword,
        }),
      )
        .then(() => {
          toast.success("Password reset successfully!");
          onClose();
          setStep(1);
          setFormData({
            email: "",
            code: "",
            password: "",
            confirmPassword: "",
          });
        })
        .catch((err) => {
          if (
            err?.status === 400 ||
            err?.message?.toLowerCase().includes("invalid")
          ) {
            toast.error("Invalid OTP or data. Please check!");
          } else {
            toast.error("Something went wrong. Try again.");
          }
        });
    }
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content border-0 rounded-3 shadow-lg">
          {/* Header */}
          <div className="modal-header bg-light text-white">
            <h5 className="modal-title mb-0">
              {step === 1 && "Forgot Password"}
              {step === 2 && "Verify Code"}
              {step === 3 && "Reset Password"}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {step === 1 && (
                <div className="mb-3">
                  <label className="form-label">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {step === 2 && (
                <>
                  {" "}
                  <div className="mb-3">
                    <label className="form-label">Verification Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      placeholder="Enter 6-digit verification code"
                      value={formData.code}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 6) {
                          setFormData({ ...formData, code: value });
                        }
                      }}
                      maxLength={6}
                      required
                    />
                  </div>
                  <div className="mb-3 position-relative">
                    <label className="form-label">New Password</label>

                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control pe-5"
                      name="password"
                      placeholder="Enter new password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />

                    <span
                      className="position-absolute end-0 translate-middle-y me-3"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer", zIndex: 5, top: "72%" }}
                    >
                      <i
                        className={`bi ${
                          showPassword ? "bi-eye" : "bi-eye-slash"
                        }`}
                      ></i>
                    </span>
                    {formData.password && passwordError && (
                      <small style={{ color: "red" }}>{passwordError}</small>
                    )}
                  </div>
                  <div className="mb-3 position-relative">
                    <label className="form-label">Confirm Password</label>

                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control pe-5"
                      name="confirmPassword"
                      placeholder="Confirm your password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />

                    <span
                      className="position-absolute  end-0 translate-middle-y me-3"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{ cursor: "pointer", zIndex: 5, top: "56%" }}
                    >
                      <i
                        className={`bi ${
                          showConfirmPassword ? " bi-eye" : "bi-eye-slash"
                        }`}
                      ></i>
                    </span>
                    {confirmPasswordError && (
                      <small className=" d-block mt-1" style={{ color: "red" }}>
                        {confirmPasswordError}
                      </small>
                    )}
                  </div>
                </>
              )}

              <div className="text-end">
                <button type="submit" className="btn btn-light text-white">
                  {step === 1 && "Send Code"}
                  {step === 2 && "Reset Password"}
                  {/* {step === 3 && "Reset Password"} */}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
